import { useQuery } from '@tanstack/react-query';
import { fetchPagesSlugs, type PagesSlugsResponse } from '@/utils/pagesAPI';

export function usePagesSlugs() {
  console.log('🔵 [usePagesSlugs] Hook called');

  const result = useQuery<PagesSlugsResponse, Error>({
    queryKey: ['pagesSlugs'],
    queryFn: () => {
      console.log('🔵 [usePagesSlugs] Query function executing');
      return fetchPagesSlugs();
    },
    staleTime: 10 * 60 * 1000, // 10 minutes - this data doesn't change often
    gcTime: 30 * 60 * 1000, // 30 minutes
  });

  console.log('🔵 [usePagesSlugs] Result:', {
    isLoading: result.isLoading,
    isError: result.isError,
    data: result.data ? { total: result.data.total } : null,
    error: result.error?.message
  });

  return result;
}
